import { Badge, Button, Flex, Td, Text, Tr } from "@chakra-ui/react";
import moment from "moment";
import React from "react";

function TablesTableRow(props) {
  const {
    name,
    email,
    username,
    numberID,
    status,
    verifiedDate,
    lastItem,
    click,
  } = props;

  const colorBGStatus = {
    approved: "green.400",
    failed: "red.400",
    processing: "orange.400",
    "approved user send payment 20": "cyan.600",
  };

  return (
    <Tr>
      <Td
        minWidth={{ sm: "250px" }}
        ps="0px"
        border={lastItem ? "none" : null}
        borderBottomColor="#56577A"
      >
        <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
          <Flex direction="column">
            <Text fontSize="sm" color="#fff" fontWeight="normal" minWidth="100%">
              {name}
            </Text>
            <Text fontSize="sm" color="gray.400" fontWeight="normal">
              {email}
            </Text>
          </Flex>
        </Flex>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A" minW="150px">
        <Flex direction="column">
          <Text fontSize="sm" color="#fff" fontWeight="normal">
            {username}
          </Text>
        </Flex>
      </Td>

      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A" minW="150px">
        <Flex direction="column">
          <Text fontSize="sm" color="#fff" fontWeight="normal">
            {numberID}
          </Text>
        </Flex>
      </Td>
      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Badge
          bg={colorBGStatus[status]}
          color={"white"}
          fontSize="sm"
          p="3px 10px"
          borderRadius="8px"
          border={"none"}
          fontWeight="normal"
        >
          {status == "approved user send payment 20" ? "Approved + Payment" : status}
        </Badge>
      </Td>
      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A" minW="150px">
        <Flex direction="column">
          <Text fontSize="sm" color="#fff" fontWeight="normal">
            {status == "approved" || status == "approved user send payment 20"
              ? moment(verifiedDate).format("YYYY-MM-DD hh:mm")
              : "-"}
          </Text>
        </Flex>
      </Td>
      {/* <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Text fontSize="sm" color="#fff" fontWeight="normal">
          {date}
        </Text>
      </Td> */}
      <Td border={lastItem ? "none" : null} borderBottomColor="#56577A">
        <Button p="0px" bg="transparent" variant="no-hover" onClick={click}>
          <Text fontSize="sm" color="gray.400" fontWeight="bold" cursor="pointer">
            View
          </Text>
        </Button>
      </Td>
    </Tr>
  );
}

export default TablesTableRow;
